/** The printed width of an A4 page, in CSS pixels. */
export const PAGE_WIDTH_PX = 794;
const DESKTOP_MARGIN_PX = 48;
const PHONE_MARGIN_PX = 16;
const MIN_FIT_ZOOM = 0.35;
const MAX_FIT_ZOOM = 1;

/**
 * The zoom that makes an A4 page (794 CSS px) fill the viewport width, from 35 % up to 100 %: the page
 * is never enlarged past its printed size on opening. An unmeasured viewport (`0`) gives 100 %.
 */
const resolveFitZoom = (viewportWidth: number, isCompact: boolean): number => {
	if (viewportWidth <= 0) {
		return MAX_FIT_ZOOM;
	}

	const available = viewportWidth - (isCompact ? PHONE_MARGIN_PX : DESKTOP_MARGIN_PX);

	return Math.min(
		MAX_FIT_ZOOM,
		Math.max(MIN_FIT_ZOOM, Math.round((available / PAGE_WIDTH_PX) * 100) / 100),
	);
};

export default resolveFitZoom;
